import React from "react";
import { useLocation, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * ProfileCompletionGuard — Iter45.6.
 *
 * Wraps the AppShell. Whenever a logged-in user has
 * `needs_profile_completion === true`, redirects them to
 * `/onboarding/complete-profile?next=<current>` — unless they're already on
 * that page, an auth page, or the legal pages (privacy/terms/safety, which
 * they may need to read BEFORE completing signup).
 */
const ALLOWED_WHILE_INCOMPLETE = [
  "/onboarding/complete-profile",
  "/auth",
  "/auth/google/finish",
  "/auth/forgot",
  "/auth/reset",
  "/privacy",
  "/terms",
  "/safety",
  "/trust",
];

export default function ProfileCompletionGuard({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || !user) return children;
  if (!user.needs_profile_completion) return children;

  const isAllowed = ALLOWED_WHILE_INCOMPLETE.some(
    (p) => location.pathname === p || location.pathname.startsWith(p + "/")
  );
  if (isAllowed) return children;

  const next = encodeURIComponent(location.pathname + location.search);
  return <Navigate to={`/onboarding/complete-profile?next=${next}`} replace />;
}
